<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{dialogData.doc_name}}</h5>
      <div class="edit-icons" (click)="onCancel()" mat-dialog-close >
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="modal-max item-content">

        <div class="profile-img m-auto mt-3  mt-xl-5" [appBackgroundImg]="dialogData.e_data.p_pic"></div>
        <h6 class="text-black text-center mt-3 mb-0">{{dialogData.e_data.f_n}} {{dialogData.e_data.l_n}}</h6>
        <div class="drop-box m-auto mt-3 mt-lg-4  m-w" *ngIf="(!isFileUploaded && (dialogData.d_tp==false))">
            <ngx-dropzone (change)="onSelect($event)" class="drop-item"   accept="image/jpeg,image/jpg,image/png,image/gif" >
                <ngx-dropzone-label >
                    <div class="d-flex">
                        <div class="upload-img mr-2">
                            <img src="assets/images/icons/upload.svg" class="img-fluid">
                        </div>
                        <div>
                            <div>Click to Upload</div>
                            <div class="upload-text">Or just drag and drop</div>
                        </div>
                    </div>
                </ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)" [removable]="true" >
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>
        </div>
        <div class="uploaded-container m-auto mt-3 mt-lg-4  m-w"  *ngIf="isFileUploaded">
            <i class="material-icons close-icon" (click)="onDeleteFile()">close</i>
            <div class="uploaded-box d-flex align-items-center justify-content-center">
                <div class="upload-img">
                    <img src="assets/images/object_icons/upload_file.png" class="img-fluid">
                </div>
                <div class="ps-4 d-flex flex-column justify-content-center upload-content">
                    <div class="uploaded-txt">{{ getFileName(dialogData.data)}}</div>
                    <div class="mt-1 text-medium">Uploaded Successfully</div>
                </div>
            </div>
        </div>
        <div class="mat-table__message" *ngIf="(!isFileUploaded && (dialogData.d_tp==true))">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
          </div>
    </div>
    <div class="item-footer d-flex align-items-center justify-content-center">
        <button mat-raised-button color="warn" class="auth-form-btn  success-btn me-3 mt-3 mt-lg-4" type="submit" *ngIf="isFileUploaded" (click)="onView()">
            {{ "BUTTON.VIEW" | translate }}</button>
        <button mat-raised-button color="primary" class="auth-form-btn  me-3 mt-3 mt-lg-4" type="submit" *ngIf="isFileUploaded"
        (click)="onDownload(dialogData.data)">{{"BUTTON.DOWNLOAD" | translate}}</button>   
        <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" [disabled]="(files.length==0)" *ngIf="!isFileUploaded"
        (click)="onSave()">{{ "BUTTON.SAVE" | translate }}</button>
    </div>

</div>
<app-loading-spinner></app-loading-spinner>